RivalIQ.apps.Discovery.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const PostMetrics = RivalIQ.views.ItemView.extend({
        template: '#discoveryNumericPostMetricLayoutTemplate',
        className: 'metric-row',

        ui: {
            information: '.fa-info-circle',
            tooltip: '[data-toggle="tooltip"]'
        },

        serializeData: function () {
            const me = this;
            // titleize metric property if there is no defined name for it
            return me.model.attributes;
        },

        onRenderLoaded: function () {
            const me = this;
            me.ui.information.popover();
            me.ui.tooltip.tooltip();
        }
    });

    views.PostDetails = RivalIQ.views.LayoutView.extend({
        template: '#discoveryPostDetailsTemplate',
        className: 'container-fluid discovery-post-details',

        regions: {
            metricsRegion: '.metrics-region'
        },

        serializeData: function () {
            const me = this;
            const post = me.model.toJSON();
            const postMessage = _.get(post, ['rivaliq', 'display', 'message']);

            const messageWithParagraphs = _.map((postMessage || '').split(/\n+/), function (para) {
                return $.tagHtml('p', {
                    class: 'word-break-word',
                    text: para
                });
            }).join('\n');
            const useThumbnailUrl = post.channel === RivalIQ.enums.channels.INSTAGRAM;
            const useCdnThumbnail = RivalIQ.apps.SocialPosts.utils.shouldUseCdnThumbnail(useThumbnailUrl, post.image);

            return _.extend({
                postLink: null,
                video: undefined,
                useCdnThumbnail: useCdnThumbnail
            }, _.omit(post, 'rivaliq'), post.rivaliq.display, {
                message: messageWithParagraphs,
                video: RivalIQ.apps.SocialPosts.utils.makePreviewVideoUrl(post.rivaliq.display.video)
            }, App.utils.generateProfileLinks(post.user.handle, me.getOption('channel')));
        },

        templateHelpers: function () {
            const me = this;

            return _.extend({
                s: s,
                channel: me.getOption('channel')
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        },

        onRenderLoaded: function () {
            const me = this;

            const View = Marionette.CollectionView.extend({
                childView: PostMetrics,
                className: 'metric-layout'
            });

            me.metricsRegion.show(new View({
                collection: new Backbone.Collection(me.getPostMetrics())
            }));
        },

        getPostMetrics: function () {
            const me = this;
            return _.map(me.getOption('postDetailMetrics'), function (metric) {
                const metricAttrs = {};
                const metricVal = me.model.get(metric.property);
                return _.extend(metricAttrs, {
                    name: RivalIQ.metric.names.metricName(metric),
                    description: RivalIQ.metric.search.getPropertyValue(metric, 'description'),
                    value: metricVal,
                    abbreviatedVal: RivalIQ.formatter.formatAbbreviated(metricVal),
                    submetrics: metric.property === 'engagement_total' ? me.getEngagementTotalSubmetrics() : []
                });
            });
        },

        getEngagementTotalSubmetrics: function () {
            const me = this;
            const channel = me.getOption('channel');

            const configs = [
                {
                    engagement_type: 'applause'
                },
                {
                    engagement_type: (channel === RivalIQ.enums.channels.INSTAGRAM ? 'conversation' : 'amplification')
                }
            ];

            return _.map(configs, function (config) {
                const built = RivalIQ.metric.build(config, {
                    channel: channel,
                    dataSource: 'discovery',
                    dimensions: ['channel', 'engagement_type', 'post'],
                    property: 'engagement_total'
                });

                const definition = new RivalIQ.models.MetricDefinition(built);
                return {
                    name: definition.getName(),
                    description: definition.getDescription(),
                    value: me.model.get(config.engagement_type),
                    abbreviatedVal: RivalIQ.formatter.formatAbbreviated(me.model.get(config.engagement_type))
                };
            });
        }
    });

}, window.s);
